import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import PurchaseCart from "../../components/screen/purchaseOnlinePbf/PurchaseCart";

const PurchaseCartPbfPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <PurchaseCart />
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gray"}
      noPadding={true}
    />
  );
};

export default HOC(PurchaseCartPbfPage);
